// ABOUTME: Scroll-to-top component that resets scroll position on route changes
// ABOUTME: Prevents React Router and browser scroll restoration from preserving scroll position
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// TD3-200: Scroll to top on every route change for better UX
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    console.log(`🔝 ScrollToTop: Route changed to ${pathname}`);
    console.log(`📏 Current scroll position before: ${window.scrollY}`);

    // Disable browser scroll restoration (Chrome, Firefox, Safari)
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
      console.log('✅ Browser scroll restoration disabled');
    }

    // TD3-200 FIX: Temporarily disable smooth scrolling to ensure instant scroll
    const htmlElement = document.documentElement;
    const originalScrollBehavior = htmlElement.style.scrollBehavior;
    htmlElement.style.scrollBehavior = 'auto'; // Disable smooth scroll

    // Scroll to top immediately (no animation)
    window.scrollTo(0, 0); // Simple form - no options object

    // Restore smooth scroll behavior after a brief delay
    setTimeout(() => {
      htmlElement.style.scrollBehavior = originalScrollBehavior;
      console.log(`📏 Scroll position after scrollTo: ${window.scrollY}`);
    }, 0);
  }, [pathname]); // Run on every route change

  return null; // This component doesn't render anything
}
